import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { GetPaymentsListResponse, PaymentInfo } from 'typings/payment'
import type { ServerError } from 'typings/serverError'
// eslint-disable-next-line import/no-cycle
import { fetchPaymentList, refreshPaymentList } from './async-thunks'

export const initState: PaymentInfo = {
  dataList: [],
  currentPage: 1,
  limit: 10,
  paymentCount: 0,
  isDataLoading: true,
  isPaymentResponseFail: false,
  errorMessage: '',
  error: false,
  gridOption: {
    columnID: '',
    currentPage: 1,
    limit: 10,
    sortColumn: '',
    sortOrder: ''
  },
  filterOption: {}
}

const handleFetchTableFulfilledCase = (
  state: PaymentInfo,
  { payload }: PayloadAction<GetPaymentsListResponse>
) => {
  const { payments, currentPage, pageSize, totalPayments } = payload
  state.dataList = payments
  state.currentPage = currentPage
  state.limit = pageSize
  state.paymentCount = totalPayments
}

const handleFetchTableRejectionCase = (
  state: PaymentInfo,
  { payload }: PayloadAction<unknown>
) => {
  const { businessErrorCode, statusCode, response } = payload as ServerError
  // UI related state
  state.isPaymentResponseFail = true
  state.isDataLoading = false
  state.dataList = []

  // Request error specific
  state.errorMessage = response?.message
  state.error = !!businessErrorCode
  state.status = statusCode.toString()
}

export const paymentHistorySlice = createSlice({
  name: 'paymentHistorySlice',
  initialState: initState,
  reducers: {
    setCurrentPage: (state, { payload }: { payload: number }) => {
      state.gridOption.currentPage = payload
    },
    setPageSize: (state, { payload }: { payload: number }) => {
      state.gridOption.limit = payload
    },
    /**
     * @deprecated - create actions to update slice state
     */
    updatePaymentList: (
      state: PaymentInfo,
      action: PayloadAction<PaymentInfo>
    ) => {
      return {
        ...state,
        ...action.payload
      }
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchPaymentList.pending, state => {
        state.isDataLoading = true
      })
      .addCase(
        fetchPaymentList.fulfilled,
        (
          state: PaymentInfo,
          action: PayloadAction<GetPaymentsListResponse>
        ) => {
          handleFetchTableFulfilledCase(state, action)
          state.isDataLoading = false
        }
      )
      .addCase(fetchPaymentList.rejected, handleFetchTableRejectionCase)

    builder
      .addCase(refreshPaymentList.fulfilled, handleFetchTableFulfilledCase)
      .addCase(refreshPaymentList.rejected, handleFetchTableRejectionCase)
  }
})

export const { updatePaymentList } = paymentHistorySlice.actions

export const { setCurrentPage, setPageSize } = paymentHistorySlice.actions

export default paymentHistorySlice.reducer
